import React from 'react';
import './App.css';
import SocialLinksHub from './SocialLinksHub';

function App() {
  return (
    <SocialLinksHub />
  );
}

export default App;
